import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { OrderService } from './order.service';
import { OrderDetails } from '../shared/model/order-details.model';
import { CartPaymentService } from './card-payment.service';
import { environment } from 'src/environments/environment';
import { DataShareService } from '../shared/data-share.service';
import { LoadingScreenService } from '../common/loading/loading-screen.service';

declare let paysafe: any
declare let $: any

@Component({
  selector: 'creditcard-payment',
  templateUrl: './creditcard-payment.component.html',
  styleUrls: ['./creditcard-payment.component.css']
})
export class CreditCardPaymentComponent implements OnInit {

  paysafeError: String;
  isCardDeclined: boolean = false;
  paysafeInstance;
  hostedPaymentToken: string;
  orderDetails: OrderDetails = new OrderDetails();

  paramSubscribe: any;
  constructor(private cartPaymentService: CartPaymentService,
    private orderService: OrderService,
    private loadingScreenService: LoadingScreenService,
    private dataShareService: DataShareService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.loadingScreenService.startLoading();
    let instance = this;
    let form = $('#payment-form');
    form.find('.pay').prop('disabled', true);
    const OPTIONS = {
      environment: environment.paysafeEnvironment,
      fields: {
        cardNumber: {
          selector: "#cardNumber",
          placeholder: ""
        },
        expiryDate: {
          selector: "#cardExpiry",
          placeholder: ""
        },
        cvv: {
          selector: "#cardCVC",
          placeholder: ""
        }
      }
    }

    this.paramSubscribe = this.activatedRoute.params.subscribe(params => {
      this.hostedPaymentToken = params['hostedPaymentToken'];

      paysafe.fields.setup(environment.paysafeApiToken, OPTIONS, (paysafeInstance: any, error: any) => {
        if (error) {
          //alert(`Setup error: [${error.code}] ${error.detailedMessage}`);
          this.router.navigate(['/hosted/error/internal-server-error']);
        } else {
          instance.paysafeInstance = paysafeInstance;
          //var payButton = form.find('.pay');
          instance.paysafeInstance.fields("cvv cardNumber expiryDate").valid(function (eventInstance, event) {
            $(event.target.containerElement).closest('.form-control').removeClass('error').addClass('success');
            if (instance.paymentFormReady()) {
              form.find('.pay').prop('disabled', false);
            }
          });
  
          instance.paysafeInstance.fields("cvv cardNumber expiryDate").invalid(function (eventInstance, event) {
            $(event.target.containerElement).closest('.form-control').removeClass('success').addClass('error');
            if (!instance.paymentFormReady()) {
              form.find('.pay').prop('disabled', true);
            }
          });
  
          instance.paysafeInstance.fields.cardNumber.on("FieldValueChange", function (instance, event) {
            console.log(instance.fields.cardNumber);
          });
          
          this.orderService.getOrderByHostedPaymentToken(this.hostedPaymentToken).subscribe(
            data => {
              if (data == null) {
                this.router.navigate(['/hosted/error/internal-server-error']);
              }
              this.orderDetails = data;
              this.loadingScreenService.stopLoading();
              //this.dataShareService.add('onCancelUri',this.orderDetails.onCancelUri);
            },
            error => {
              console.log("Error: Unable to fetch order");
              if (error.status == 400 || error.status == 404) {
                this.router.navigate(['/hosted/error/page-not-found']);
              } else if (error.status == 500) {
                this.router.navigate(['/hosted/error/internal-server-error']);
              } else if (error.status == 0 || error.status == 503) {
                this.router.navigate(['/hosted/error/service-unavailable']);
              } else {
                this.router.navigate(['/hosted/error/internal-server-error']);
              }
            },
            () => {
            }
          );
          
        }
      });
    });
  }

  pay(cardPaymentNgForm: NgForm) {
    let instance = this;
    let form = $('#payment-form');
    if (!instance.paysafeInstance) {
      console.log('No instance');
      this.router.navigate(['/hosted/error/internal-server-error']);
    } else {
      form.find('.pay').prop('disabled', true);
      form.find('.pay').html('Processing <i class="fa fa-spinner fa-pulse"></i>');
      instance.paysafeError = null;
      instance.isCardDeclined = false;
      instance.paysafeInstance.tokenize((paysafeInstance: any, error: any, result: any) => {
        if (error) {
          //alert(`Tokenization error: [${error.code}] ${error.detailedMessage}`);
          //this.router.navigate(['/hosted/error/internal-server-error']);
          //instance.isCardDeclined = false;
          instance.paysafeError = error.detailedMessage
          form.find('.pay').prop('disabled', false);
          form.find('.pay').html('Pay');
        } else {
          //alert(`Token: ${result.token}`);
          //instance.paysafeError = null;
          //instance.isCardDeclined = false;
          this.cartPaymentService.purchase(this.hostedPaymentToken, result.token).subscribe(
            data => {
              //this.router.navigate(['/hosted/card/payment/success']);
              $('#paymentConfirmationModel').modal('show');
              setTimeout(() => {
                window.location.href = this.orderDetails.onSuccessUri;
              }, environment.redirectWaitSeconds * 1000);
            }, error => {
              if (error.status == 402) {
                //instance.paysafeError = "Payment not processed. " + error.error.message;
                instance.isCardDeclined = true;
                form.find('.pay').prop('disabled', false);
                form.find('.pay').html('Pay');
              } else if (error.status == 400 || error.status == 404) {
                this.router.navigate(['/hosted/error/card-payment-hosted']);
              } else if (error.status == 500 || error.status == 502) {
                this.router.navigate(['/hosted/error/internal-server-error']);
              } else if (error.status == 0) {
                this.router.navigate(['/hosted/error/service-unavailable']);
              } else {
                this.router.navigate(['/hosted/error/internal-server-error']);
              }
            }, () => {
            }
          );
        }
      })
    }
  }

  paymentFormReady() {
    let form = $('#payment-form');
    if (form.find('#cardNumber').hasClass("success") &&
      form.find('#cardExpiry').hasClass("success") &&
      form.find('#cardCVC').hasClass("success")) {
      return true;
    } else {
      return false;
    }
  }

  cancelPayment() {
    window.location.href = this.orderDetails.onCancelUri;
  }

  ngOnDistroy() {
    this.paramSubscribe.unsubscribe();
  }

}